import api from './api'

export const authService = {
  // Configuration du token d'authentification
  setAuthToken: (token) => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
      delete api.defaults.headers.common['Authorization']
    }
  },

  // Connexion
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials)
    return response.data
  },

  // Inscription
  register: async (userData) => {
    const response = await api.post('/auth/register', userData)
    return response.data
  },

  // Déconnexion
  logout: async () => {
    const response = await api.post('/auth/logout')
    return response.data
  },

  // Récupération des informations utilisateur
  getMe: async () => {
    const response = await api.get('/auth/me')
    return response.data.user
  },

  // Configuration de la double authentification
  setupTwoFactor: async () => {
    const response = await api.post('/auth/setup-2fa')
    return response.data
  },

  // Vérification de la double authentification
  verifyTwoFactor: async (token) => {
    const response = await api.post('/auth/verify-2fa', { token })
    return response.data
  },

  // Désactivation de la double authentification
  disableTwoFactor: async (password) => {
    const response = await api.post('/auth/disable-2fa', { password })
    return response.data
  },

  // Réinitialisation de mot de passe (à implémenter)
  resetPassword: async (email) => {
    const response = await api.post('/auth/reset-password', { email })
    return response.data
  },

  // Confirmation de réinitialisation de mot de passe (à implémenter)
  confirmResetPassword: async (token, newPassword) => {
    const response = await api.post('/auth/confirm-reset-password', {
      token,
      newPassword
    })
    return response.data
  }
}